// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2b7II","productName":"Table_productName__1vHxa"};